export default __webpack_public_path__ + "static/media/logo-white.ef12e649.png";